var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app", staticStyle: { background: "white" } },
    [
      _c(
        "div",
        { staticClass: "add" },
        [_c("longcode", { attrs: { onecode: 2 } })],
        1
      ),
      _vm._v(" "),
      _vm.botn ? _c("div", { staticClass: "tishibor" }) : _vm._e(),
      _vm._v(" "),
      _vm.botn
        ? _c("div", { staticClass: "zhidao" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "bot", on: { click: _vm.clickBot } }, [
              _vm._v("知道了")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: [_vm.botn == true ? "op" : ""] }, [_c("Return")], 1)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("i", { staticClass: "iconfont iconanquan" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cen" }, [
      _vm._v("\n      付款码数字仅用于支付时向收银员展示,"),
      _c("br"),
      _vm._v("请勿发送给他人,以防诈骗\n    ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4657bb2f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4657bb2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/CodeDetails/index.vue
// module id = null
// module chunks = 